import {
  AssetListPerformanceScenario,
  AssetBasicModel,
  useListAssets,
  AssetsListFilterParams,
} from '@customer/store/apis/assetsApi';
import { useAppDispatch } from '@customer/store/hooks';
import { useCallback } from 'react';
import {
  AssetSidePanelTab,
  openSidePanel,
  SidePanel,
  usePerformanceTimeRangeFilters,
} from '@customer/store/slices/globalSlice';
import { FilterGroup } from '@customer/filters/types';
import useFilters from '@customer/filters/useFilters';
import { useLocationFilterParams } from '@customer/store/slices/locationFilterSlice';

interface UsePerformanceSubPageProps {
  scenario: AssetListPerformanceScenario;
  sidePanelTab: AssetSidePanelTab;
  sidePanelDefaultAccordion: string;
  filterGroup: FilterGroup;
}

export const usePerformanceSubPage = <FiltersSubset extends AssetsListFilterParams>({
  scenario,
  sidePanelTab,
  sidePanelDefaultAccordion: defaultAccordion,
  filterGroup,
}: UsePerformanceSubPageProps) => {
  const dispatch = useAppDispatch();

  const timeRangeFilters = usePerformanceTimeRangeFilters();

  const filters = useFilters<FiltersSubset>(filterGroup);

  const locationFilters = useLocationFilterParams({ filterGroup });

  const { assets, hasData, noDataDescription, countAll, countFilter, countScenarioFilter } =
    useListAssets({
      query: {
        ...filters,
        ...locationFilters,
        ...timeRangeFilters,
        scenario,
      },
    });

  const onRowClick = useCallback(
    (data: AssetBasicModel) => {
      dispatch(
        openSidePanel({
          sidePanel: SidePanel.Asset,
          modelId: data.id.toString(),
          tab: sidePanelTab,
          defaultAccordion,
        }),
      );
    },
    [dispatch, sidePanelTab, defaultAccordion],
  );

  return {
    assets,
    hasData,
    noDataDescription,
    countAll,
    countFilter,
    countScenarioFilter,
    onRowClick,
  };
};

export default usePerformanceSubPage;
